import { systemEngineEnvironment } from "services/environment/systemEngine";

export type Table = {
  tableName: string;
  tableType: string;
  tableOwner: string;
  created: string;
  lastAltered: string;
};

export const getDatabaseTables = async (
  database: string,
  options?: {
    byOwnerUsername?: string;
    includeTableTypes?: string[];
    endpoint?: string;
  }
) => {
  let byOwnerWhere = "";

  if (options?.byOwnerUsername) {
    byOwnerWhere = `where table_owner = '${options.byOwnerUsername}'`;
  }

  const result = await systemEngineEnvironment.execute<Table>(
    `select table_name, table_type, table_owner, created, last_altered from information_schema.tables ${byOwnerWhere}`,
    { database, endpoint: options?.endpoint }
  );

  const includeTypes = options?.includeTableTypes ?? [
    "BASE TABLE",
    "FACT",
    "DIMENSION",
    "EXTERNAL",
  ];

  const [response] = result;
  return response.rows.filter(table => includeTypes.includes(table.tableType));
};
